const actions = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  STORE_CARDS: "STORE_CARDS",
  login: (payload) => ({
    type: actions.LOGIN,
    payload,
  }),
  logout: () => ({
    type: actions.LOGOUT,
  }),
  storeCards: (payload) => ({
    type: actions.STORE_CARDS,
    payload,
  }),
};

export default actions;
